import * as HttpService from './http.service';
import {
    GET_EXISTING_PROPOSAL_URL,
    SEND_PROPOSAL_URL, UPDATE_PROPOSAL_ON_ACTION, UPDATE_PROPOSAL_URL, WITHDRAW_PROPOSAL_URL, GET_DEMAND_PROPOSALS_URL,
    CREATE_PROPOSAL_SUGGESTION_URL, GET_PROPOSAL_SHIFT_TIMINGS_BY_PROPOSAL_ID
} from './url.service';

export const sendProposal = (
    resourceId,
    demandId,
    userId,
    engagementManager,
    startDate,
    endDate,
    weeklyHours,
    source = '',
    gigResourceId = null,
    softBlockedId = null,
    suggestionId = null,
    functionCode,
    proposalShiftTimings = [],
    isSpecialProject = false
) => HttpService.postWithAuth(SEND_PROPOSAL_URL(resourceId), {
    demandId,
    userId,
    engagementManager,
    startDate,
    endDate,
    weeklyHours,
    proposalOrSuggestionShiftTimings: proposalShiftTimings,
    isSpecialProject,
    source,
    gigResourceId,
    softBlockedId,
    suggestionId,
    functionCode
});

export const updateProposal = (
    id,
    resourceId,
    demandId,
    startDate,
    endDate,
    weeklyHours,
    proposalOrSuggestionShiftTimings,
    functionCode,
    isSpecialProject = false
) => HttpService.putWithAuth(UPDATE_PROPOSAL_URL(resourceId, id), {
    demandId,
    startDate,
    endDate,
    weeklyHours,
    proposalOrSuggestionShiftTimings,
    functionCode,
    isSpecialProject
});

export const updateProposalOnAction = ({ id, type, body }) => HttpService.putWithAuth(UPDATE_PROPOSAL_ON_ACTION(id, type), body);

export const withdrawProposal = (
    id,
    demandId,
) => HttpService.putWithAuth(WITHDRAW_PROPOSAL_URL(id), {
    demandId
});

export const getExistingProposals = (resourceId, startDate, endDate) => HttpService.getWithAuth(GET_EXISTING_PROPOSAL_URL(resourceId, startDate, endDate));
export const proposalStatusMap = {
    pending: 'Proposed',
    accepted: ' Awaiting allocation',
    rejected: 'Rejected'
};
export const getDemandProposals = (id) => HttpService.getWithAuth(GET_DEMAND_PROPOSALS_URL(id));

export const createProposalOrSuggestionService = (
    resourceId,
    data
) => HttpService.postWithAuth(CREATE_PROPOSAL_SUGGESTION_URL(resourceId), data);


export const getProposalShiftTimingsByProposalId = ({ proposalId }) => {
    return HttpService.getWithAuth(GET_PROPOSAL_SHIFT_TIMINGS_BY_PROPOSAL_ID({ proposalId }));
}